exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".would-you-like-to > h2 {\n  line-height: 37px;\n  font-size: 30px;\n  margin-bottom: 0;\n}\n@media (max-width: 846px) {\n.would-you-like-to {\n    margin-left: 16px;\n    margin-right: 16px;\n}\n}\n@media (max-width: 569px) {\n.would-you-like-to .would-you-like-to-blocks {\n    justify-content: space-around;\n}\n}", ""]);

// exports
